import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import breakpoint from 'styled-components-breakpoint';

const Wrapper = styled.div`
  height: 222px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #2757f4;
  font-weight: 700;
  font-size: 16px;
  line-height: 21px;
  color: #ffffff;
  margin-top: 79px;
  width: 100%;
  padding: 40px;
  box-sizing: border-box;

  ${breakpoint('tablet')`
    font-size: 23px;
    line-height: 30px;
    letter-spacing: 0.6px;
  `};
`;

const BlueBlock = () => {
  return (
    <Wrapper>
      <FormattedMessage
        id="homeredesign.blueblock.text"
        defaultMessage="999 – самый доступный вариант продвижения вашего бизнеса в Молдове!"
      />
    </Wrapper>
  );
};

export default BlueBlock;
